import { ChevronDown, Star } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

import useSearchParamActions from '@/customHooks/useSearchParamActions';
import { useGetPartnersQuery } from '../partner/partner.api.slice';
import { IPartnerData } from '../partner/partner';

function ToolTypeFilter() {
  const { appendSearchParam, removeSearchParam } = useSearchParamActions();

  const { data: partnerData, isLoading } = useGetPartnersQuery();

  if (!isLoading && partnerData?.length === 0) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>;
  }

  if (!partnerData) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="gap-2">
          Partners
          <ChevronDown className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem
          onClick={() => {
            removeSearchParam('partner');
          }}
        >
          All
        </DropdownMenuItem>
        {partnerData.map((partner: IPartnerData) => (
          <DropdownMenuItem
            key={partner._id}
            onClick={() => {
              appendSearchParam('partner', partner.user);
            }}
          >
            <div
              className="h-6 w-6 rounded-full flex items-center justify-center"
              style={{
                backgroundColor: partner?.color,
              }}
            >
              <Star className="h-1 w-1 text-white" fill="white" />
            </div>
            {partner.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default ToolTypeFilter;
